import { createRouter, createWebHistory } from 'vue-router';
import HomeComponent from '@/components/Home/HomeComponent.vue';
import HelpComponent from '@/components/Help/HelpComponent.vue';
import PrivacyTerms from '@/components/PrivacyTermsComponent/PrivacyTermsComponent.vue';
import TermsOfUse from '@/components/PrivacyTermsComponent/Terms/TermsOfUse.vue';
import PrivacyPolicy from '@/components/PrivacyTermsComponent/Privacy/PrivacyPolicy.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeComponent,
  },
  {
    path: '/privacy',
    name: 'PrivacyTerms',
    component: PrivacyTerms,
    redirect: { name: 'TermsOfUse' },
    children: [
      {
        path: 'terms-of-use',
        name: 'TermsOfUse',
        component: TermsOfUse,
      },
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
      },
    ],
  },
  {
    path: '/help',
    name: 'Help',
    component: HelpComponent,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;